import { render, staticRenderFns } from "./DiscountVdh.vue?vue&type=template&id=02dfc052&"
var script = {}
import style0 from "./DiscountVdh.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports